export const animationFrameHelper = (entries: any, method: any) => {
	// We wrap it in requestAnimationFrame to avoid this error - ResizeObserver loop limit exceeded
	window.requestAnimationFrame(() => {
		if (!Array.isArray(entries) || !entries.length) {
			return;
		}
		method();
	});

} 